import React, { useState } from 'react';
import './styles';

import WebinarVideoIcon from 'assets/images/webinar-video-icon.svg';
import ShareIcon from 'assets/images/share-icon.svg';
import Icon from 'shared/components/Icon';

import ReactPlayer from 'react-player';

const WebinarVideo = ({ title, videoURL }) => {
  const [copyLinkLabel, setCopyLinkLabel] = useState('Copy Link');
  const copyLink = (event) => {
    event.preventDefault();

    navigator.clipboard.writeText(window.location.href.split('?')[0]);
    setCopyLinkLabel('Link copied!');
  };

  return (
    <div className="webinar-video-wrapper">
      {videoURL ? (
        <>
          <div className="video-container-header">
            <div className="on-demand-tag">
              <Icon icon={WebinarVideoIcon} className={'on-demand-icon'} />
              <span>Webinar</span>
            </div>
            <div className="share" onClick={copyLink}>
              <span>{copyLinkLabel}</span>
              <Icon icon={ShareIcon} />
            </div>
          </div>
          <div className="video-details">
            <div className="video-header">
              <div className="video-title">
                <h1>{title}</h1>
              </div>
            </div>
            <div className="player-wrapper">
              <ReactPlayer
                className="react-player"
                url={videoURL}
                width="100%"
                height="100%"
                controls
              />
            </div>
          </div>
        </>
      ) : (
        <span> This Webinar content is not available </span>
      )}
    </div>
  );
};

export default WebinarVideo;
